<template>
  <!-- 弹窗 -->
  <el-dialog :title="mode" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
    <div style="">
      <el-input v-model="remark" type="textarea" max="255" :rows="5" placeholder="请输入审核意见"></el-input>
      <div style="text-align: center;font-size: 10px;color: grey;margin-top: 10px;margin-bottom: 50px"></div>

      <!-- <div style="text-align: center;margin-bottom: 10px;color: grey;font-size: 10px">同意时以下内容必填</div>-->

      <!-- <div style="display: flex;width: 80%">
           <div style="width: 200px">近三年继续教育学时</div>
           <el-input v-model="hour" type="number" size="mini"></el-input>
       </div>

       <div style="margin-top: 10px;display: flex;margin-bottom: 50px">
           <div style="width: 200px">安全证明</div>
           <el-radio-group v-model="safe" size="mini">
               <el-radio label="1" border>有</el-radio>
               <el-radio label="0" border>无</el-radio>
           </el-radio-group>
       </div>-->

      <div style="margin-top: 10px">
                <span slot="footer" class="dialog-footer" >

                    <el-button type="primary" @click="app(1)">同意</el-button>
                     <el-button @click="app(0)">退回</el-button>
                </span>
      </div>

    </div>
  </el-dialog>
</template>

<script>
import {

  setRecommendApp
} from '../../../api/moudles/management.js'

export default {

  name:'qcApp',
  data() {
    return {
      mode: '审核',
      dialogVisible: false,
      hour:'',
      safe:'',
      remark:'',
      ids:''
    }
  },
  components: {},

  methods: {

    //审核推荐接口
    async app(type){

      if(this.remark ==''){
        this.$message({
          message: '审核意见不能为空',
          type: 'error'
        });
        return
      }
      /* if(type == 1){
           if(this.safe =='' || this.study_hour =='' ){

               this.$message({
                   message: '学时和安全证明必填哦',
                   type: 'error'
               });
               return
           }
       }*/

      await setRecommendApp({

        data: {
          ids: this.ids,
          remark:this.remark,
          safe:this.safe,
          hour:this.hour,
          type:type
        },
        success: res => {

          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.dialogVisible = false
            setTimeout(() => {
              //this.$router.go(-1)
              //this.$router.push('qcContribute')
              this.handleClose()
              this.$emit('fetchData', {})

            }, 1000)
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            });

          }

        }
      })
    },

    showAdd(params) {

      console.log(params)
      this.dialogVisible = true

      this.ids = params.ids

    },
    handleClose() {
      this.dialogVisible = false
    },

  }
}
</script>

<style scoped="scoped">
.el-dialog__header {
  height: 100px;
  line-height: 100px;
}

.el-dialog__body {
  padding: 10px 20px;
}

>>>.el-dialog {
  border-radius: 6px;
}

/* 模板下载 */
.mubanDown {
  display: flex;
  height: 40px;
  line-height: 40px;
  justify-content: space-between;
  align-items: center;
}

.mubanDown button {
  cursor: pointer;
  width: 80px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #1890FF;
  font-size: 12px;
  background-color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1890FF;
}

.innerdialog_list {
  padding-top: 20px;
  display: flex;
  /* height: 40px; */
  align-items: flex-start;
  line-height: 40px;
  align-content: flex-start;
  margin-bottom: 10px;
  border-bottom: 1px solid #B5B5B5;
}

/* .innerdialog_list p {

} */
.listP {
  font-size: 14px;
  width: 80px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
}

.innerdialog_list span {
  display: block;
  font-size: 12px;
  width: 40px;
  margin-left: 20px;
  height: 20px;
  line-height: 20px;
  background: #FFFFFF;
  text-align: center;
  border: 1px solid #1890FF;
  cursor: pointer;
}

.list_center {
  width: 310px;
  min-height: 40px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}

/* 每个上传文件的样式 */
.inner_upload {
  position: relative;
  height: 40px;
  margin: 0 10px;
  /* width: 100px; */
  /* overflow: scroll; */
}

.inner_upload p {
  color: #1890FF;
}

.inner_upload img {
  position: absolute;
  right: 0;
  top: 0;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

/* 保存提示 */
.tipList p {
  line-height: 25px;
  text-align: left;
}

.tipList p:first-child {
  margin-bottom: 20px;
}

/* gridtable */
table.gridtable {
  font-family: verdana,arial,sans-serif;
  font-size:14px;
  color:#333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
}
table.gridtable th {
  border-width: 1px;
  padding: 12px;
  border-style: solid;
  border-color: #666666;
  background-color: #dedede;
}
table.gridtable td {
  border-width: 1px;
  padding: 22px;
  border-style: solid;
  border-color: #666666;
  background-color: #ffffff;
}

table.gridtable .el-input__inner{
  border: none;
}

/* /gridtable */

</style>
